const DEFAULT_DATA = () => ({
  data: null,
  type: "CREATE",
  status: false,
  componentName: "",
  componentProps: {},
});

export default {
  state: {
    defaultModalData: DEFAULT_DATA(),

    viewDataBISistems: {
      status: false,
      data: {},
      isSlideShow: false,
      slideList: [],
    },
  },

  getters: {
    getDefaultModalData(state) {
      return state.defaultModalData;
    },

    getViewDataBISistems(state) {
      return state.viewDataBISistems;
    },
  },

  mutations: {
    clearModalInfos(state) {
      state.defaultModalData = DEFAULT_DATA();
    },

    setModalStatus(state, status) {
      state.defaultModalData.status = !!status;
    },

    setDefaultModalInfos(state, infos) {
      if (infos == null) return (state.defaultModalData = DEFAULT_DATA());

      if (String(infos) !== "[object Object]")
        return (state.defaultModalData = DEFAULT_DATA());

      // Definindo as propriedades padrões caso não seja definido na chamada
      infos = Object.entries(DEFAULT_DATA()).reduce((acc, [key, value]) => {
        if (acc[key] === undefined || acc[key] === null) {
          acc[key] = value;

          return acc;
        }

        return acc;
      }, infos);

      state.defaultModalData.data = infos.data;
      state.defaultModalData.type = infos.data === null ? "CREATE" : "EDIT";
      state.defaultModalData.status = infos.status;
      state.defaultModalData.componentName = infos.componentName;

      state.defaultModalData.componentProps = Object.entries(
        infos.componentProps,
      ).reduce((acc, [key, value]) => {
        if (typeof value == "function") {
          acc[key] = value(infos.data);

          return acc;
        }

        acc[key] = value;

        return acc;
      }, {});
    },

    setViewDataBISistems(state, infos) {
      state.viewDataBISistems = {
        status: infos.status,
        data: infos.data !== null ? infos.data : {},
        isSlideShow: infos.isSlideShow || false,
        slideList: infos.slideList || [],
      };
    },
  },

  actions: {
    changeDefaultModalInfos(context, infos) {
      context.commit("setDefaultModalInfos", infos);
    },

    changeViewDataModal(context, infos) {
      context.commit("setViewDataBISistems", infos);
    },

    changeClearModalInfos(context) {
      context.commit("clearModalInfos");
    },

    changeModalStatus(context, status) {
      context.commit("setModalStatus", status);
    },
  },
};
